import React from 'react';
import {Row} from "antd";
import {ArrowLeftOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";

const DG_Button = props => {

    const form = props.form
    const mode = props.mode
    const success = props.success
    const onChangeSuccess = props.onChangeSuccess
    const navigate = useNavigate();


    return (
        <>
            {
                props.position === 'footer' ? (
                    <Row align="bottom"
                         {...props}
                        style={{
                            padding: props.padding ? props.padding : '0 13px'
                        }}
                    >

                        {React.Children.map(props.children, child => {
                            return React.cloneElement(child, {form, mode, success, onChangeSuccess})
                        })}
                    </Row>
                ) : (
                    <div
                        className={`bg-white rounded-lg items-center flex justify-between`}
                        style={{
                            borderBottom: '1px solid #EAECF0',
                            paddingLeft: '26px',
                            paddingRight: '24px',
                            height: '68px'}}
                    >
                        <div style={{fontSize: '18px', fontWeight: '600', lineHeight: '28px', color: '#101828'}}>
                            {props.title && (
                                <>
                                    {props.disableIcon !== true && <ArrowLeftOutlined className={'mr-3 text-black'} onClick={() => {
                                        navigate(-1)
                                    }}/>}
                                    {props.title}
                                </>
                            )}
                        </div>
                        <div className={'flex'}>
                            {React.Children.map(props.children, child => {
                                return React.cloneElement(child, {form, mode, success, onChangeSuccess})
                            })}
                        </div>
                    </div>
                )
            }
        </>
    );
};

DG_Button.propTypes = {};

export default DG_Button;
